import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilsClassificationService } from 'src/app/classification/utils.service';
import { DiscriminatorTypeEnum } from 'src/app/shared/enum/discriminator-type.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';
import { DiscriminatorModel } from 'src/app/shared/services/models/risk-classification/discriminator.model';
import { DeviceTypeSectorResponse } from 'src/app/shared/services/responses/risk-classification/device-type-sector.response';

@Component({
    selector: 'app-respiratory-frequency-modal',
    templateUrl: './respiratory-frequency-modal.component.html',
    styleUrls: ['./respiratory-frequency-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RespiratoryFrequencyModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<RespiratoryFrequencyModalComponent>,
    private formBuilder: UntypedFormBuilder,
    private alertService: AlertService, private utilService: UtilsClassificationService, private maskService: MaskService) { }

  public model: UntypedFormGroup;
  public discriminator: DiscriminatorModel;
  public masks: Masks;
  public discriminatorType: DiscriminatorTypeEnum = DiscriminatorTypeEnum.FrequenciaRespiratoria;
  public autisticChecked: boolean = false;
  public setUppercaseText: boolean = false;

  ngOnInit(): void {
    let deviceTypeSectorResponse: DeviceTypeSectorResponse = this.utilService.getDevicetypeBySector()
    if (deviceTypeSectorResponse && deviceTypeSectorResponse.deviceTypeSector) {
      if (deviceTypeSectorResponse.deviceTypeSector.setUppercaseText)
        this.setUppercaseText = deviceTypeSectorResponse.deviceTypeSector.setUppercaseText;
    }

    this.masks = this.maskService.getMasks();
    this.discriminator = this.data.discriminator;

    let value = this.data.discriminatorsValues && this.data.discriminatorsValues[this.discriminatorType] ? this.data.discriminatorsValues[this.discriminatorType] : null;
    this.model = this.formBuilder.group({
      respiratoryFrequency: [value, Validators.required],
      priorityAutistic: [false],
      discriminatorSelectionMotive: []
    });
  }

  changePriorityAutistic(event: any) {
    this.model.get('respiratoryFrequency').setValue(null);
    this.autisticChecked = event.checked
    if (event.checked) {
      this.model.get('discriminatorSelectionMotive').setValidators([Validators.required]);
      this.model.get('respiratoryFrequency').disable();
    } else {
      this.model.get('discriminatorSelectionMotive').setValidators(Validators.nullValidator);
      this.model.get('respiratoryFrequency').enable();
    }
    this.model.get('discriminatorSelectionMotive').updateValueAndValidity();
  }

  close() {
    this.matDialogRef.close();
  }

  submit() {
    if (this.model.invalid) {
      if (this.model.get('priorityAutistic').value) {
        this.alertService.show('Erro', "Preencha o motivo!", AlertType.error);
      } else {
        this.alertService.show('Erro', "Preencha o campo da Frequência respiratória!", AlertType.error);
      }
      return;
    }
    if (this.model.get('priorityAutistic').value) {
      this.matDialogRef.close({ value: null, select: true, motive: this.model.get('discriminatorSelectionMotive').value });
    } else {
      let value = this.model.get("respiratoryFrequency").value.replace("_", "")

      let select = this.utilService.verifySelectGeneric(this.discriminator.minValueAllowed, this.discriminator.maxValueAllowed, value);
      if (this.discriminator.minValueAllowed != null && this.discriminator.maxValueAllowed != null) {
        select = !select;
      }
      this.matDialogRef.close({ value, select });
    }
  }
}

